// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, func, string } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { deleteProjectsById } from 'helpers/api'
import { loadingToggler } from 'redux/modules/loading'
import { UNCAUGHT_ERROR } from 'errors'

import {
  DeleteConfirmation,
  DeleteFail,
  DeleteSuccess,
} from 'components/Modals'

class DeleteProjects extends React.Component {
  static propTypes = {
    closeModal: func.isRequired,
    highlightedRows: array.isRequired,
    modalTemplate: string.isRequired,
    sourceForm: string.isRequired,
    triggerSearch: func.isRequired,
  }

  state = {
    modalHeading: 'Delete Confirmation',
    modalMessage: 'Are you sure you want to delete the selected project(s)?',
    workFlowStep: 'confirmation',
  }

  confirmDelete = async () => {
    const {
      highlightedRows,
      loadingToggler,
      sourceForm,
      triggerSearch,
    } = this.props

    return loadingToggler(async () => {
      try {
        await deleteProjectsById(highlightedRows)
        await triggerSearch(sourceForm)
        this.setState(() => ({
          modalHeading: 'Warning!',
          modalMessage: 'Successfully deleted the project(s).',
          workFlowStep: 'success',
        }))
      } catch (err) {
        console.warn(err)
        this.setState(() => ({
          modalHeading: 'Warning!',
          modalMessage: err.message || UNCAUGHT_ERROR,
          workFlowStep: 'error',
        }))
      }
    })
  }

  renderTemplate = () => {
    const { confirmDelete } = this
    const { closeModal } = this.props
    const {
      modalHeading,
      modalMessage,
      workFlowStep,
    } = this.state

    switch (workFlowStep) {
      case 'confirmation' :
        return (
          <DeleteConfirmation
            closeModal={closeModal}
            confirmAction={confirmDelete}
            modalHeading={modalHeading}
            modalMessage={modalMessage} />
        )
      case 'error' :
        return (
          <DeleteFail
            modalHeading={modalHeading}
            modalMessage={modalMessage} />
        )

      case 'success' :
        return (
          <DeleteSuccess
            closeModal={closeModal}
            modalHeading={modalHeading}
            modalMessage={modalMessage} />
        )

      default :
        return (
          'Warning: Unmapped workflow template in <DeleteProject />'
        )
    }
  }

  render () {
    return this.renderTemplate()
  }
}

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    loadingToggler,
  }, dispatch)
)

export default connect(
  () => ({}),
  mapDispatchToProps
)(DeleteProjects)
